export const SET_FILTER = 'SET_FILTER/LYBUNT/@WISELY/WEB';

export const setFilter = payload => ({
	type: SET_FILTER,
	payload,
});



// WEBPACK FOOTER //
// ./src/redux/lybunt/lybunt.action.js